import { isMobileDevice } from "@/modules/main/mobile/isMobile.ts";
import { atomWithSessionStorage } from "@/utils/jotai/atomStorage.ts";

export const sideNavCompactAtom = atomWithSessionStorage<boolean>("adminSideNavCompact", isMobileDevice);
